// extracted by mini-css-extract-plugin
export default {"body":"power-bi-delete-confirm-dialog_body__FT0eT","mimic-notice":"power-bi-delete-confirm-dialog_mimic-notice__EBo0i"};